/* ============================================================
   KINGPIN GYMWEAR — Royal JS v2
   Animations · Tabs · Scroll reveals · Sticky ATC · Loader
   ============================================================ */

(function () {
  'use strict';

  /* ── 1. PAGE LOADER ─────────────────────────────────────── */
  function initLoader() {
    const loader = document.querySelector('.kp-page-loader');
    if (!loader) return;
    window.addEventListener('load', () => {
      setTimeout(() => loader.classList.add('loaded'), 400);
    });
  }

  /* ── 2. HERO HEADLINE WORD WRAP ─────────────────────────── */
  function initHeroWords() {
    document.querySelectorAll('.banner__heading').forEach(heading => {
      const text = heading.textContent.trim();
      const words = text.split(/\s+/);
      heading.innerHTML = words.map(w =>
        `<span class="kp-word"><span>${w}</span></span>`
      ).join(' ');
    });
  }

  /* ── 3. SCROLL REVEAL ───────────────────────────────────── */
  function initScrollReveal() {
    const els = document.querySelectorAll('.kp-reveal, .kp-gold-rule');
    if (!els.length) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('kp-revealed');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(el => obs.observe(el));
  }

  /* ── 4. COLLECTION TABS ─────────────────────────────────── */
  function initCollectionTabs() {
    document.querySelectorAll('.kp-tabs-nav').forEach(nav => {
      const section = nav.closest('.kp-tabs-section');
      if (!section) return;

      nav.querySelectorAll('.kp-tab-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const target = btn.dataset.tab;

          // Update buttons
          nav.querySelectorAll('.kp-tab-btn').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');

          // Update panels with crossfade
          section.querySelectorAll('.kp-tab-panel').forEach(panel => {
            if (panel.dataset.tab === target) {
              panel.style.display = 'block';
              requestAnimationFrame(() => panel.classList.add('active'));
            } else {
              panel.classList.remove('active');
              setTimeout(() => {
                if (!panel.classList.contains('active')) panel.style.display = 'none';
              }, 350);
            }
          });
        });
      });
    });
  }

  /* ── 5. PRODUCT PAGE TABS ───────────────────────────────── */
  function initProductTabs() {
    document.querySelectorAll('.product-tabs').forEach(tabWrap => {
      tabWrap.querySelectorAll('.product-tab-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const target = btn.dataset.tab;
          const wrap = btn.closest('.product-tabs');

          wrap.querySelectorAll('.product-tab-btn').forEach(b => b.classList.remove('active'));
          wrap.querySelectorAll('.product-tab-content').forEach(p => p.classList.remove('active'));

          btn.classList.add('active');
          const panel = wrap.querySelector(`.product-tab-content[data-tab="${target}"]`);
          if (panel) panel.classList.add('active');
        });
      });
      // Activate first tab by default
      const firstBtn = tabWrap.querySelector('.product-tab-btn');
      if (firstBtn) firstBtn.click();
    });
  }

  /* ── 6. STICKY ATC ON PRODUCT PAGE ─────────────────────── */
  function initStickyATC() {
    const atc = document.querySelector('.kp-sticky-atc');
    const form = document.querySelector('.product-form, [data-type="add-to-cart-form"]');
    if (!atc || !form) return;

    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        atc.classList.toggle('visible', !e.isIntersecting);
      });
    }, { threshold: 0 });
    obs.observe(form);
  }

  /* ── 7. HEADER SCROLL EFFECT ────────────────────────────── */
  function initHeaderScroll() {
    const header = document.querySelector('.header-wrapper');
    if (!header) return;
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('scrolled', y > 80);
      lastY = y;
    }, { passive: true });
  }

  /* ── 8. STATS COUNTER ANIMATION ─────────────────────────── */
  function animateCounter(el) {
    const target = parseInt(el.dataset.target || el.textContent, 10);
    const suffix = el.dataset.suffix || '';
    const duration = 1800;
    const start = performance.now();
    const ease = t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

    function step(now) {
      const elapsed = Math.min((now - start) / duration, 1);
      el.textContent = Math.round(ease(elapsed) * target).toLocaleString() + suffix;
      if (elapsed < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initStatsCounters() {
    const counters = document.querySelectorAll('.kp-stat-number[data-target]');
    if (!counters.length) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          animateCounter(e.target);
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(c => obs.observe(c));
  }

  /* ── 9. CARD "CLAIM YOURS" OVERLAY INJECT ───────────────── */
  function initCardOverlays() {
    document.querySelectorAll('.card__media').forEach(media => {
      if (!media.querySelector('.kp-claim-overlay')) {
        const overlay = document.createElement('div');
        overlay.className = 'kp-claim-overlay';
        overlay.textContent = 'CLAIM YOURS';
        media.appendChild(overlay);
      }
    });
  }

  /* ── 10. MARQUEE DUPLICATE (ensure seamless loop) ────────── */
  function initMarquee() {
    document.querySelectorAll('.kp-marquee-track').forEach(track => {
      // Items already duplicated in HTML for seamless loop
      // Just ensure animation resets cleanly
      track.addEventListener('animationiteration', () => {
        // No-op: CSS handles it
      });
    });
  }

  /* ── 11. SMOOTH ANCHOR SCROLL ────────────────────────────── */
  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', e => {
        const target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── 12. IMAGE BANNER PARALLAX ───────────────────────────── */
  function initParallax() {
    const banner = document.querySelector('.banner__media');
    if (!banner || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y < window.innerHeight) {
        banner.style.transform = `translateY(${y * 0.25}px)`;
      }
    }, { passive: true });
  }

  /* ── 13. MODAL SYSTEM ─────────────────────────��─────────── */
  function initModals() {
    // Open
    document.querySelectorAll('[data-modal]').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const modal = document.getElementById(trigger.dataset.modal);
        if (!modal) return;
        modal.classList.add('open');
        modal.focus();
        document.body.style.overflow = 'hidden';
      });
    });

    // Close via button
    document.querySelectorAll('[data-modal-close]').forEach(btn => {
      btn.addEventListener('click', () => {
        const modal = btn.closest('.kp-modal-backdrop');
        if (!modal) return;
        closeModal(modal);
      });
    });

    // Close via backdrop click
    document.querySelectorAll('.kp-modal-backdrop').forEach(modal => {
      modal.addEventListener('click', e => {
        if (e.target === modal) closeModal(modal);
      });
    });

    // Close via Escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        document.querySelectorAll('.kp-modal-backdrop.open').forEach(closeModal);
      }
    });
  }

  function closeModal(modal) {
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ── 14. SIZE GUIDE TABS ─────────────────────────��───────── */
  function initSizeGuideTabs() {
    document.querySelectorAll('.kp-size-tabs-nav').forEach(nav => {
      nav.querySelectorAll('.kp-size-tab-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const target = btn.dataset.sizeTab;
          const modal = btn.closest('.kp-modal-panel');
          if (!modal) return;

          nav.querySelectorAll('.kp-size-tab-btn').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');

          modal.querySelectorAll('.kp-size-panel').forEach(panel => {
            if (panel.dataset.sizePanel === target) {
              panel.style.display = 'block';
            } else {
              panel.style.display = 'none';
            }
          });
        });
      });
    });
  }

  /* ── INIT ───────────────────────────────────────────────── */
  function init() {
    initLoader();
    initHeroWords();
    initScrollReveal();
    initCollectionTabs();
    initProductTabs();
    initStickyATC();
    initHeaderScroll();
    initStatsCounters();
    initCardOverlays();
    initMarquee();
    initSmoothAnchors();
    initParallax();
    initModals();
    initSizeGuideTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run card overlays after Shopify section renders
  document.addEventListener('shopify:section:load', () => {
    initCardOverlays();
    initCollectionTabs();
    initProductTabs();
    initScrollReveal();
  });

})();
